module.exports = __webpack_public_path__ + "static/media/thumbup--big.1fb2d8fc.png";